export default {
    list: [],
    statuses: [],
    productTemplates: [],
}
